module.exports = {
    viasName: () => {
        return[
            ["Avenida Norte", "Calle 74","Transversal 2A"]
        ]
    }
}